export const BASE_API_URL = document.location.protocol + '//'
    + document.location.host.replace(':'+document.location.port, '') + '/api';